import {type UserNs} from "@shared/types/user.namespace";
import {ScreenNs} from "@shared/types/screen.namespace";

export namespace FeatureNs {

    export enum NodeType {
        FEATURE = 'FEATURE',
        PAGE = 'PAGE',
        APP_DETAIL = 'APP_DETAIL',
    }

    export enum FeatureTypeEnums {
        GROUP = 'GROUP',
        FEATURE = 'FEATURE',
        SUB_FEATURE = 'SUB_FEATURE',

        // just for distinguishing input fields from normal features on editor tree!
        INPUT = 'INPUT',
        // just for distinguishing project page from normal features node on editor tree!
        PAGE = 'PAGE',

        FP_MODULES = 'FP_MODULES'
    }

    export interface FeatureTreeNode extends Feature {
        hidden: boolean,
        color: string,
        parentColor: string,
        hasChildren: boolean,
        isIndex: boolean,
        children: FeatureTreeNode[]
    }

    export interface Feature {
        id: string,
        parentId: string,
        summary: string,
        featureType: FeatureTypeEnums,
        createdBy: UserNs.AuditUser,
        createDate: Date,
        updatedBy: UserNs.AuditUser,
        updateDate: Date,
        intIssueKey: string,
        description: string,
        intProperties: any,
        screens: ScreenNs.Screen[],
        properties?: any,
    }

    /** Get All Feature Request */
    export interface GetAllFeatureRequest {
        workspaceId: string;
        projectId: string;
        parentId: string;
    }

    /** Update Feature Parent Request */
    export interface UpdateFeatureParentRequest {
        workspaceId: string;
        projectId: string;
        featureId: string;
        parentId: string;
    }

    /** Update Feature Request */
    export interface UpdateFeatureRequest {
        workspaceId: string;
        projectId: string;
        feature: any;
        featureList: any[];
        isTreeStructure:boolean;
    }

    /** Update Feature Request */
    export interface AddGroupsAndFeaturesRequest {
        workspaceId: string;
        projectId: string;
        groups: any[];
    }

    /** Update Feature on Tree */
    export interface SetFeatureProperty {
        key: string;
        value: any;
    }

    export interface PageTreeNode extends ProjectPage {
        hidden: boolean,
        isIndex: boolean,
        children: PageTreeNode[]
    }

    export interface ProjectPage {
        id: string,
        featureType: FeatureTypeEnums,
        isSummary: boolean,
        summary: string,
        description: string;
        properties?: any;
        createdBy: UserNs.AuditUser,
        createDate: Date,
        updatedBy: UserNs.AuditUser,
        updateDate: Date,
        screens: ScreenNs.Screen[]
    }

    /** Get All Project Page Request */
    export interface GetAllProjectPageRequest {
        workspaceId: string;
        projectId: string;
    }

    /** Update Project Page Request */
    export interface UpdateProjectPageRequest {
        workspaceId: string;
        projectId: string;
        projectPage: any;
        projectPageList: any[];
    }

    /** Search Feature Request */
    export interface SearchFeatureRequest {
        workspaceId: string;
        projectId: string;
        searchStr: string;
    }

    export interface SearchFeatureResponse {
        featureId: string,
        summary: string,
        featureType: FeatureTypeEnums,
        projectName: string,
        projectId: string,
        properties?:any,
    }

    export interface ImportFeatureRequest {
        workspaceId: string;
        projectId: string;
        featureProjectId: string,
        featureId: string,
        parentIdToAdd: string;
    }

    export interface FeatureSynchStatus {
        id: string;
        transactionType: string;
        updateDate: Date,
    }

    export interface SendToJiraRequest {
        workspaceId: string;
        projectId: string;
        featureIds: string[],
        sendAllWaitingFeature:boolean
    }

    export interface SendToAzureRequest {
        workspaceId: string;
        projectId: string;
        featureIds: string[];
        sendAllWaitingFeature: boolean;
        integrationType: 'AZURE';
    }
}
